var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-border-waves text-white pt-16"},[_c('v-img',{attrs:{"src":require("@/assets/images/borderWavesBlue.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }